var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00245 2.25154L1.06162 10.4999C0.959749 10.6763 0.905848 10.8763 0.905278 11.08C0.904708 11.2837 0.957487 11.484 1.05837 11.661C1.15925 11.838 1.30471 11.9855 1.48028 12.0888C1.65585 12.1921 1.85542 12.2476 2.05912 12.2499H11.9408C12.1445 12.2476 12.344 12.1921 12.5196 12.0888C12.6952 11.9855 12.8407 11.838 12.9415 11.661C13.0424 11.484 13.0952 11.2837 13.0946 11.08C13.0941 10.8763 13.0402 10.6763 12.9383 10.4999L7.99745 2.25154C7.89346 2.0801 7.74704 1.93836 7.57232 1.83999C7.39759 1.74162 7.20046 1.68994 6.99995 1.68994C6.79944 1.68994 6.60231 1.74162 6.42759 1.83999C6.25286 1.93836 6.10644 2.0801 6.00245 2.25154V2.25154Z",
    stroke: "#FAAD14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.25V7.58333",
    stroke: "#FAAD14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.9165H7.00583",
    stroke: "#FAAD14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e8dc3e1e.svg";
export { ForwardRef as ReactComponent };